import React from 'react';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';
import { CountUp } from '../CountUp';
import { achievements, executiveRoles, accents } from '../../data/site';
export function Achievements() {
  return <section className="boardroom-light relative overflow-hidden py-24 lg:py-32" data-id="element-62" data-mp="1kne6bnz3v9b8">
      <div className="aurora" aria-hidden="true" data-id="element-63" data-mp="1fpcmh0tuv5yp" />
      <div className="pattern-lattice-dark absolute inset-0 opacity-50" aria-hidden="true" data-id="element-64" data-mp="2dbth1yb7f5gr" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10" data-id="element-65" data-mp="28cqcsg31t39u">
        <SectionHeading eyebrow="By the Numbers" title="Measured in transactions closed and risk governed." tone="dark" align="center" data-id="element-66" data-mp="28d8hm13s0ptd" />

        <dl className="mt-16 grid gap-px overflow-hidden border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-67" data-mp="1ym5iv5ybkmx9">
          {achievements.map((stat, index) => {
          const accent = accents[index % accents.length];
          return <Reveal key={stat.label} delay={index % 3 * 0.06} className="group relative overflow-hidden bg-navy-800/70 px-8 py-12 text-center backdrop-blur-md transition-colors duration-500 hover:bg-navy-700/70" data-id="element-68" data-mp="2nqextbb376xk" data-mpi={index}>
                <span className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100" style={{
              background: `radial-gradient(70% 60% at 50% 0%, ${accent}55, transparent 70%)`
            }} aria-hidden="true" data-id="element-69" data-mp="2dyiy5vtcr8r8" />
                <dt className="sr-only" data-id="element-70" data-mp="1v1r6axzqvlbk">{stat.label}</dt>
                <dd className="relative" data-id="element-71" data-mp="1v3c20qxspab0">
                  <span className="block font-display text-5xl font-light text-white lg:text-6xl" data-id="element-72" data-mp="200c7p0qqgb1l">
                    <CountUp value={stat.value} prefix={stat.prefix} suffix={stat.suffix} data-id="element-73" data-mp="3pfs7hpiroket" />
                  </span>
                  <span className="mx-auto mt-5 block h-0.5 w-10 transition-all duration-500 group-hover:w-20" style={{
                backgroundColor: accent
              }} aria-hidden="true" data-id="element-74" data-mp="3uevbd6n0gkl7" />
                  <span className="mt-4 block text-[0.7rem] uppercase tracking-micro text-slate-300" data-id="element-75" data-mp="3o0g09t5d3e5q">
                    {stat.label}
                  </span>
                </dd>
              </Reveal>;
        })}
        </dl>

        <Reveal delay={0.1} className="mt-12 flex flex-wrap items-center justify-center gap-3" data-id="element-76" data-mp="fj32bkdn1llb">
          {executiveRoles.map((role, index) => <span key={role} className="glass-dark rounded-full px-6 py-2.5 text-[0.7rem] uppercase tracking-micro text-slate-100 transition-all duration-300 hover:-translate-y-0.5" style={{
          borderColor: `${accents[index % accents.length]}99`
        }} data-id="element-77" data-mp="ajyrkpb2ffsv" data-mpi={index}>
              {role}
            </span>)}
        </Reveal>
      </div>
    </section>;
}